import React, { useEffect, useState, useMemo } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import {
  get_Delete_ExpenseCategory,
  get_Expense_Category,
  get_Income_Category,
  get_Insert_ExpenseCategory,
  get_Single_Expense_Category,
  get_Update_ExpenseCategory,
} from "../../../store/actions/CommanAction";
import Loader from "../Loader/Loader";

const ExpenseCategory = () => {
  const dispatch = useDispatch();
  const ExpenseCategory = useSelector(
    (state) => state.feedBackReducer.ExpenseCategory
  );

  const cleanedExpenseCategory = ExpenseCategory?.length ? ExpenseCategory.map((item) => {
    return {
      ...item,
      Category: item.Category?.replace(/["\\]/g, ""),
      UserID: item?.UserID?.replace(/["\\]/g, ""),
      Username: item?.Username?.replace(/["\\]/g, ""),
      Url: item?.Url?.replace(/["\\]/g, ""),
      ApiKey: item?.ApiKey?.replace(/["\\]/g, ""),
      ApiSecretkey: item?.ApiSecretkey?.replace(/["\\]/g, ""),
      Password: item?.Password?.replace(/["\\]/g, ""),
      Notes: item?.Notes?.replace(/["\\]/g, ""),
    };
  }) : [];

  const SingleExpenseCategory1 = useSelector(
    (state) => state.feedBackReducer.SingleExpenseCategory
  );

  const SingleExpenseCategory = useMemo(() => {
    if (!SingleExpenseCategory1?.length) return [];
    return SingleExpenseCategory1.map((item) => {
      return {
        ...item,
        Category: item.Category?.replace(/["\\]/g, ""),
        UserID: item?.UserID?.replace(/["\\]/g, ""),
        Username: item?.Username?.replace(/["\\]/g, ""),
        Url: item?.Url?.replace(/["\\]/g, ""),
        ApiKey: item?.ApiKey?.replace(/["\\]/g, ""),
        ApiSecretkey: item?.ApiSecretkey?.replace(/["\\]/g, ""),
        Password: item?.Password?.replace(/["\\]/g, ""),
        Notes: item?.Notes?.replace(/["\\]/g, ""),
      };
    });
  }, [SingleExpenseCategory1]);

  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [ExpenseCategoryID, setExpenseCategoryID] = useState("");
  const [loading, setloading] = useState(false);
  const [addFormData, setaddFormData] = useState({
    Category: "",
    Name: "",
    Username: "",
    ApiUrl: "",
    Key: "",
    SecretKey: "",
    Password: "",
    Notes: "",
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({
      ...addFormData,
      Category: "",
      Name: "",
      Username: "",
      ApiUrl: "",
      Key: "",
      SecretKey: "",
      Password: "",
      Notes: "",
    });
  };

  useEffect(() => {
    dispatch(get_Expense_Category(IsActive, setloading));
  }, [dispatch]);

  useEffect(() => {
    if (SingleExpenseCategory) {
      setEditValue(SingleExpenseCategory);
    }
  }, [SingleExpenseCategory]);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Expense_Category("1", setloading));
    } else {
      dispatch(get_Expense_Category("0", setloading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        ExpenseCategoryID: ExpenseCategoryID,
        Category: EditValue[0]?.Category,
        Name: EditValue[0]?.UserID,
        Username: EditValue[0]?.Username,
        ApiUrl: EditValue[0]?.Url,
        Key: EditValue[0]?.ApiKey,
        SecretKey: EditValue[0]?.ApiSecretkey,
        Password: EditValue[0]?.Password,
        Notes: EditValue[0]?.Notes,
        ModifiedByUser: "1",
      });
    }
  }, [EditValue]);



  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    if (addFormData.Category === "") {
      swal("Oops", "Please fill Skill.", "error");
      return;
    }

    const newCustomerStory = {
      Category: addFormData.Category,
      IsActive: addFormData.IsActive,
      ApiSecretkey: addFormData.SecretKey,
      ApiKey: addFormData.Key,
      Password: addFormData.Password,
      UserID: addFormData.Name,
      Url: addFormData.ApiUrl,
      Notes: addFormData.Notes,
    };

    try {
      await dispatch(
        get_Insert_ExpenseCategory(
          newCustomerStory.Category,
          newCustomerStory.IsActive,
          newCustomerStory.ApiSecretkey,
          newCustomerStory.ApiKey,
          newCustomerStory.Password,
          newCustomerStory.UserID,
          newCustomerStory.Url,
          newCustomerStory.Notes
        )
      );

      await dispatch(get_Expense_Category(IsActive, setloading));

      swal("Good job!", "Successfully Added", "success");
      setPostModal(false);
      Reset();
      setaddFormData({
        Category: "",
        Name: "",
        Username: "",
        ApiUrl: "",
        Key: "",
        SecretKey: "",
        Password: "",
        Notes: "",
      });
    } catch (error) {
      console.error("Error while adding expense category:", error);
      swal("Oops!", "Something went wrong. Please try again.", "error");
    }
  };

  const UpdateSlider = async (event) => {
    event.preventDefault();
    if (addFormData.Category === "") {
      swal("Oops", "Please select Category.", "error");
      return;
    }

    try {
      await dispatch(
        get_Update_ExpenseCategory(
          ExpenseCategoryID,
          addFormData.Category,
          addFormData.IsActive,
          addFormData.SecretKey,
          addFormData.Key,
          addFormData.Password,
          addFormData.Username,
          addFormData.ApiUrl,
          addFormData.Notes
        )
      );

      await dispatch(get_Expense_Category(IsActive, setloading));

      swal("Good job!", "Successfully updated", "success");
      setEditModal(false);
      Reset();
      setaddFormData({
        Category: "",
        Name: "",
        Username: "",
        ApiUrl: "",
        Key: "",
        SecretKey: "",
        Password: "",
        Notes: "",
      });
    } catch (error) {
      console.error("Error while updating expense category:", error);
      swal("Oops!", "Something went wrong. Please try again.", "error");
    }
  };

  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {
    dispatch(get_Single_Expense_Category(row?.ExpenseCategoryID));
    setExpenseCategoryID(row?.ExpenseCategoryID);
    setEditModal(true);
  };

  const columns = [
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    // {
    //   name: "url",
    //   selector: (row) => row.Url,
    //   sortable: true,
    // },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.ExpenseCategoryID, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.ExpenseCategoryID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    ExpenseCategoryID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      ExpenseCategoryID: ExpenseCategoryID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };

    await AddUpdate("ExpenseCategory/Delete_ExpenseCategory", postData);
    dispatch(get_Expense_Category(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="main_card mb-2">
          <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
            <div className="card-action coin-tabs">
              <Nav as="ul" className="nav nav-tabs" role="tablist">
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="All"
                    onClick={(currentStatus) => {
                      setIsActive(true);
                    }}
                  >
                    Active
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="Inactive"
                    onClick={(currentStatus) => {
                      setIsActive(false);
                    }}
                  >
                    Inactive
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <Link
              to={"#"}
              className="btn btn-primary font-w600 "
              onClick={() => {
                setPostModal(true);
                Reset();
              }}
            >
              + New Expense Category
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">
                              Add Expense Category
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>

                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">Expense Category</label>
                                    <span className="text-danger star-error">
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Category"
                                    required="required"
                                    value={addFormData?.Category}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">Name</label>
                                   
                                  </div>

                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Name"
                                    required="required"
                                    value={addFormData?.Name}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">API Url</label>
                                   
                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="ApiUrl"
                                    required="required"
                                    value={addFormData?.ApiUrl}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">UserName</label>
                                   
                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Username"
                                    required="required"
                                    value={addFormData?.Username}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">Password</label>
                                   

                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Password"
                                    required="required"
                                    value={addFormData?.Password}
                                    onChange={handleAddFormChange}
                                  />
                                </div>


                              </div>
                            </div>

                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">Key</label>
                                   

                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Key"
                                    value={addFormData?.Key}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor=""> Secret Key</label>
                                  
                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="SecretKey"
                                    value={addFormData?.SecretKey}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div className="d-flex align-items-center">
                                    <label htmlFor="">Notes</label>
                                   
                                  </div>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Notes"
                                    value={addFormData?.Notes}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit ExpenseCategory
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                      <label htmlFor="">Expense Category</label>
                                      <span className="text-danger star-error">
                                        *
                                      </span>
                                      <input
                                        type="text"
                                        // className="form-control"
                                        autoComplete="off"
                                        name="Category"
                                        required="required"
                                        value={addFormData?.Category}
                                        onChange={handleAddFormChange}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor="">Name</label>
                                   
                                    </div>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="Name"
                                      required="required"
                                      value={addFormData?.Name}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>

                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor="">API Url</label>
                                   
                                    </div>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="ApiUrl"
                                      required="required"
                                      value={addFormData?.ApiUrl}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>

                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor="">UserName</label>
                                  
                                    </div>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="Username"
                                      required="required"
                                      value={addFormData?.Username}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>

                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor="">Password</label>
                                    
                                    </div>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="Password"
                                      required="required"
                                      value={addFormData?.Password}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>

                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor="">Key</label>
                                   
                                    </div>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="Key"
                                      value={addFormData?.Key}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>
                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor=""> Secret Key</label>
                                   
                                    </div>
                                    <input
                                      type="text"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="SecretKey"
                                      value={addFormData?.SecretKey}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>
                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                    <div className="d-flex align-items-center">
                                    <label htmlFor="">Notes</label>
                                    </div>
                                    <input
                                      type="text"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="Notes"
                                      value={addFormData?.Notes}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={cleanedExpenseCategory}
                          columns={columns}
                          selectableRowsHighlight
                          // pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />)}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={cleanedExpenseCategory}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                          />)}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default ExpenseCategory;
